export const content = {
  titel: 'Ausschreibungsprozess',
  leistungUmplanen: 'Leistung umplanen',
  vorschlaegeNichtGeprueft: 'Vorschläge noch nicht geprüft',
  inAusschreibungUebertragen: 'In Ausschreibung übertragen',
  vorschlaegeInAngebotUebertragen: 'Vorschläge in Angebot übertragen',
  hatAusstehendeAngeboteHint:
    'Es gab weitere Zusagen auf die Ausschreibung. Generiere ein Angebot im Ausschreibungsportal.',
};
